import { TouchableOpacity } from 'react-native'
import { SizableText, useTheme, XStack, YStack } from 'tamagui'
import { DesignSystem } from '@/src/design-system'
import { router } from 'expo-router'
import * as MortgageEarn from '@/src/experiences/mortgage-earn'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'

export function DocumentRequired() {
  const theme = useTheme()
  return (
    <TouchableOpacity
      style={{ flexGrow: 1 }}
      onPress={() => router.push(MortgageEarn.Navigation.Routes.MortgageEarn.route)}
      activeOpacity={0.5}
    >
      <DesignSystem.Card style={{ flexGrow: 1, backgroundColor: theme.tertiary.val }}>
        <YStack gap="$2" flex={1}>
          <SizableText fontWeight={700}>
            Mesa must verify your mortgage statement before your mortgage rewards become active.
          </SizableText>
          <SizableText size="$3">
            To verify your rewards, you must provide a recent mortgage statement (last 60 days) from
            your bank or lender.
          </SizableText>
          <XStack justify="space-between" items="center">
            <SizableText size="$3" fontWeight={700}>
              Upload Now
            </SizableText>
            <ChevronRight />
          </XStack>
        </YStack>
      </DesignSystem.Card>
    </TouchableOpacity>
  )
}
